import { ReactElement } from 'react';

import {
   componentsTranslationKeys,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmExitConfig,
} from '@dreryk/react-components';

import { ProAuctoreAndProFamiliaMissingDetailsFormController } from './ProAuctoreAndProFamiliaMissingContactDetailsForm/ProAuctoreAndProFamiliaMissingDetailsForm.types';

const useExitConfirmationConfig = (enabled: boolean): ModalConfirmExitConfig => ({
   enabled: enabled,
   title: componentsTranslationKeys.leaveForm,
   content: componentsTranslationKeys.formLeavingConfirmation,
   confirmationButtonLabel: componentsTranslationKeys.leave,
});

type ProAuctoreAndProFamiliaModalExitButtonsProps = Pick<
   ProAuctoreAndProFamiliaMissingDetailsFormController,
   'formState'
> & {
   readonly onClose: VoidFunction;
};

export const ProAuctoreAndProFamiliaModalExitButtons = (
   props: ProAuctoreAndProFamiliaModalExitButtonsProps
): ReactElement => {
   const confirmationConfig = useExitConfirmationConfig(props.formState.isDirty);
   return (
      <>
         <ModalCancelButton onClick={props.onClose} shouldConfirmExit={confirmationConfig} />
         <ModalCloseButton onClick={props.onClose} shouldConfirmExit={confirmationConfig} />
      </>
   );
};
